<template>
  <div :class="theme_css">
    <div id="chat_page_main">
      <input  type="file"  id="___file_upload" ref="referenceUpload" accept="image/*" @change="upload"/>
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable ub ub-ac ub-pc">
            <span class="other-msg" v-if="other_msg > 0">{{ other_msg }}</span>
          </span>
        </div>
        <div class="nav-middle"> {{ uinfo_to.nick.length > 6 ? uinfo_to.nick.substr(0, 5) + "..." : uinfo_to.nick }}
          <span :class="to_online ? 'online' : 'no-online'" >({{ to_online_tag }})</span>
        </div>
        <div class="nav-right" @click="clearAdminMsg()">
          <span class="nav-lable">重置</span>
        </div>
      </div>
  
  
      <div class="msg-block" :style="{ 'margin-bottom': s_margin_bom, 'min-height': s_min_h }" @click="wnd_click()">
        <div class="ub ub-ac">
          <div class="msg-system">请文明聊天，平台坚决打击一切不文明行为!</div>
        </div>
  
        <!-- 历史消息 -->
        <div class="load-history-msg ub ub-ac" v-if="txts.length !== 0" @click="get_history_msg()">
          <img src="../../assets/img/new/历史消息.png" class="history-msg-img" />
          {{ history_tip }}
        </div>
        <div class="no-history-msg" v-if="history_tip == ''"> 没有更多消息了~</div>
  
        <!-- 历史消息 -->
        <div v-for="(item, index) in history_msg" :key="index + 'his'">
          <div class="ub ub-pc us-ae msg-item" v-if="item.uid_from == to">
            <img :src="uinfo_to.photo" class="msg-img" />
  
            <!--文字-->
            <div class="msg-Angle-left" v-if="item.type == 'text'"></div>
            <div class="msg-content msg-left-color" v-if="item.type == 'text'">
              {{ item.txt }}
            </div>
  
            <!--表情-->
            <img :src="item.txt" class="msg-emoji" v-if="item.type == 'emoji'" />
  
            <!--gif-->
            <img :src="item.txt" class="msg-gif" v-if="item.type == 'gif'" />
  
            <!--pic-->
  
            <img :src="item.txt" @click="show_full(item.txt)" class="msg-pic" v-if="item.type == 'pic'"/>

             <!-- 警告 -->
             <div class="sys-left msg-content ub ub-ver" v-if="item.type == 'sys_warn'">
              <div>
                <span class="tips">类型: <span>警告</span>&nbsp;&nbsp;&nbsp;</span>
                <span class="tips">时长: <span>{{ item.txt / 1000}}秒</span> </span>
              </div>
              <div class="tips-txt">
                <span>你的账号被投诉次数过多，已触发平台警告机制，即将触发封号机制，请文明聊天，聊天过程中尽量不要收到投诉举报/拉黑等情况，以免影响你正常聊天交友，感谢你的配合</span>
              </div>
            </div>

            <!-- 封号 -->
             <div class="sys-left msg-content ub ub-ver" v-if="item.type == 'sys_kill'">
              <span>系统检测到发送的内容有违规对你进行封号</span>
              <span class="tips">类型: <span>封号</span> </span>
              <span class="tips">时长: <span>{{ item.txt.kill_time / (1000 * 60 * 60) }}小时</span> </span>
              <span class="tips">原因: <span>{{ item.txt.kill_ause }}</span> </span>
             </div>
  
          </div>
  
          <div class="ub ub-pc ub-ae msg-item" v-if="item.uid_from == uid">
            <!--文字-->
            <div class="msg-content msg-right-color" v-if="item.type == 'text'">
              {{ item.txt }}
            </div>
            <div class="msg-Angle-right" v-if="item.type == 'text'"></div>
  
            <!--表情-->
            <img :src="item.txt" class="msg-emoji" v-if="item.type == 'emoji'" />
  
            <!--gif-->
            <img :src="item.txt" class="msg-gif" v-if="item.type == 'gif'" />
  
            <!--pic-->
            <img :src="item.txt" @click="show_full(item.txt)" class="msg-pic" v-if="item.type == 'pic'"/>
  
            <img :src="uinfo_from.photo" class="msg-img" />
          </div>
  
          <div class="sys-msg ub ub-ac" v-if="item.type == 'sys'">
            <div class="msg-system">{{ item.txt }}</div>
          </div>
        </div>
  
        <!-- 显示时间：今天 -->
        <div class="sys-msg ub ub-ac" v-if="history_msg.length > 0">
          <div class="msg-system">今天</div>
        </div>
  
        <!--当前消息-->
        <div v-for="(item, index) in txts" :key="index">
          <!-- 对方消息 -->
          <div :class="['msg-item', 'ub', 'us-ae', { 'ub-pc': !/^(sys|check)/.test(item.msg.msg_type) }]" v-if="item.tag == 'to'">

            <img :src="uinfo_to.photo" class="msg-img" />
  
            <!--文字-->
            <div class="msg-Angle-left" v-if="item.msg.msg_type == 'text'"></div>
            <div class="msg-content msg-left-color" v-if="item.msg.msg_type == 'text'">
              {{ item.msg.msg_txt_old }}
            </div>
  
            <!--表情-->
            <img :src="item.msg.msg_txt" class="msg-emoji" v-if="item.msg.msg_type == 'emoji'"/>
  
            <!--gif-->
            <img :src="item.msg.msg_txt" class="msg-gif" v-if="item.msg.msg_type == 'gif'"/>
  
            <!--pic-->
            <img :src="item.msg.msg_txt" @click="show_full(item.msg.msg_txt)" class="msg-pic" v-if="item.msg.msg_type == 'pic'"/>

            <!-- 警告 -->
            <div class="sys-left msg-content ub ub-ver" v-if="item.msg.msg_type == 'sys_warn'">
              <div>
                <span class="tips">类型: <span>警告</span></span>
                <span class="tips">时长: <span>{{ item.msg.msg_txt }}秒</span> </span>
              </div>
              <div class="tips-txt">
                <span>你的账号被投诉次数过多，已触发平台警告机制，即将触发封号机制，请文明聊天，聊天过程中尽量不要收到投诉举报/拉黑等情况，以免影响你正常聊天交友，感谢你的配合</span>
              </div>
            </div>

            <!-- 封号 -->
             <div class="sys-left msg-content  ub ub-ver" v-if="item.msg.msg_type == 'sys_kill'">
              <div>
                <span class="tips">类型: <span>封号</span></span>
                <span class="tips">时长: <span>{{ item.msg.msg_txt.kill_time }}小时</span></span>
                <span class="tips">原因: <span>{{ item.msg.msg_txt.kill_ause }}</span> </span>
              </div>
              <div class="tips-txt">
                <span>你的账号被投诉次数过多，已触发平台封号机制，请文明聊天，聊天过程中尽量不要收到投诉举报/拉黑等情况，以免影响你正常聊天交友，感谢你的配合</span>
              </div>
             </div>

             <!-- 注册引导 -->
             <div class="register-guidance-block" v-if="item.msg.msg_type == 'sys_guide_hello'">
              <div class="register-hello ub ub-ac ub-pc">
                <span>{{ item.msg.msg_txt }}</span>
              </div>
              <div class="txt">
                <p>小火柴帮你结交新朋友，也希望时刻保护你的社交安全。</p>
                <p> 为了更好的玩转小火柴，请先了解《小火柴平台行为规范》和《新手指南》。</p>
                <a @click="goto_chat_specification()">查看《小火柴平台行为规范》</a>
                <div class="line"></div>
                <a @click="goto_guidebook()">查看《新手指南》</a>
              </div>
             </div>

             <!-- 举报投诉消息提醒 -->
             <div class="tips-msg" v-if="item.msg.msg_type == 'check_complain' || item.msg.msg_type == 'check_gift'">
              <span class="title ub" v-if="item.msg.msg_type == 'check_complain'" >聊天投诉已提交</span>
              <span class="title ub" v-if="item.msg.msg_type == 'check_gift'">礼物投诉已提交</span>
              <span class="content ub">您已成功投诉{{item.msg.msg_txt.nick}}，我们会依据《小火柴平台行为规范》尽快进行处理，感谢你的投诉。</span>

              <div class="line"></div>
              <a @click="goto_chat_specification()">查看《小火柴平台行为规范》</a>
              <div class="ub ub-ae">
                  <a class="call-labor ub" @click="call_labor()">呼叫人工客服</a>
                </div>
             </div>

             <!-- 审核消息提醒 -->
             <div class="tips-msg" v-if="item.msg.msg_type == 'check_photo' || item.msg.msg_type == 'check_nick' || item.msg.msg_type == 'check_album'|| item.msg.msg_type == 'check_tx'">
                <span class="title ub" v-if="item.msg.msg_type == 'check_nick'">昵称审核中...</span>
                <span class="title ub" v-if="item.msg.msg_type == 'check_photo'" >头像审核中...</span>
                <span class="title ub" v-if="item.msg.msg_type == 'check_album'" >相册审核中...</span>
                <span class="title ub" v-if="item.msg.msg_type == 'check_tx'" >提现审核中...</span>
                <span class="content ub">{{ item.msg.msg_txt.desc }}</span>
                <div class="ub ub-ae">
                  <a class="call-labor ub" @click="call_labor()">呼叫人工客服</a>
                </div>
             </div>

          </div>
  
          <!-- 本人消息 -->
          <div class="msg-item ub ub-pc ub-ae" v-if="item.tag == 'self'">
            <!--文字-->
            <span class="msg-tip">●</span>
            <div class="msg-content msg-right-color" v-if="item.msg.msg_type == 'text'">
              {{ item.msg.msg_txt }}
            </div>
            <div class="msg-Angle-right" v-if="item.msg.msg_type == 'text'"></div>
  
            <!--表情-->
            <img :src="item.msg.msg_txt" class="msg-emoji" v-if="item.msg.msg_type == 'emoji'"/>
  
            <!--gif-->
            <img :src="item.msg.msg_txt" class="msg-gif" v-if="item.msg.msg_type == 'gif'"/>
  
            <!--pic-->
            <img :src="item.msg.msg_txt" @click="show_full(item.msg.msg_txt)" class="msg-pic" v-if="item.msg.msg_type == 'pic'"/>
  
            <img :src="uinfo_from.photo" class="msg-img" />
          </div>
  
          <div class="ub ub-ac" v-if="item.tag == 'sys'">
            <div class="msg-system">{{ item.msg.msg_txt }}</div>
          </div>

        </div>
        <!-- 管理员离线提示 -->
        <div v-if="offline_state" >
              <div class="msg-system">
                <span>客服暂时不在线，有事请留言，客服看到消息后会第一时间处理的哈</span>
              </div>
        </div>
      </div>
  
  
      <div id="send_block" class="ub ub-ver send-block">
        <div class="send-txt-con ub ub-pc" v-if="!hide_msg_input()">
          <input type="text" placeholder="请输入新消息" class="ub-f1 send-txt" v-model="txt" @blur="iosBlur()" @focus="txtFocus()"/>
          <div v-if="show_send_btn" class="btn-send" @click="send_txt()">
            <span>发 送</span>
          </div>
        </div>
  
        <chart_gif v-if="arry_menu['menu_4']" @send_gif="send_gif"></chart_gif>
        <chart_em v-if="arry_menu['menu_5']" @send_emoji="send_emoji"></chart_em>
  
        <div class="ub ub-pc send-img">
          <div class="ub ub-ac up-pc ub-f1">
            <img  v-if="arry_menu['menu_2']" src="../../assets/img/new/图片-1.png" class="send-img-item" @click="ctrl_menu(2)"/>
            <img  v-if="!arry_menu['menu_2']" src="../../assets/img/new/图片.png" class="send-img-item"  @click="ctrl_menu(2)"/>
          </div>
          <div class="ub ub-ac up-pc ub-f1">
            <img v-if="arry_menu['menu_4']" src="../../assets/img/new/gif-1.png" class="send-img-item" @click="ctrl_menu(4)"/>
            <img v-if="!arry_menu['menu_4']"  src="../../assets/img/new/gif.png" class="send-img-item" @click="ctrl_menu(4)"/>
          </div>
          <div class="ub ub-ac up-pc ub-f1">
            <img v-if="arry_menu['menu_5']" src="../../assets/img/new/表情-1.png" class="send-img-item" @click="ctrl_menu(5)"/>
            <img v-if="!arry_menu['menu_5']" src="../../assets/img/new/表情.png" class="send-img-item" @click="ctrl_menu(5)"/>
          </div>
        </div>
      </div>
  
      <alert ref="myConfirm"></alert>
  
      <dlg ref="myForm"></dlg>
  
      <full_pic ref="myFullPic"></full_pic>
  
    </div>
  </div>
    
  </template>
  
  <script>
  import { mapMutations, mapActions } from "vuex";
  import Exif from "exif-js";
  
  import * as tool from "../../api/common";
  import Chart_Em from "./Chart_Emoji.vue";
  import Chart_Gif from "./Chart_Gif.vue";
  import Alert from "../../components/Alert.vue";
  import full_pic from "../../components/Full_Pic.vue";
  import Form from "../../components/Form.vue";
  export default {
    components: {
      chart_em: Chart_Em,
      chart_gif: Chart_Gif,
      alert: Alert,
      full_pic: full_pic,
      dlg: Form,
    },
    data() {
      return {
        uid: "",
        to: "",
        txt: "",
  
        uinfo_from: {
          photo: "",
          nick: "",
          sex: "",
          age_range: "",
          score_total: 0,
          coin_total: 0,
        },
        uinfo_to: {
          photo: "",
          nick: "",
          sex: "",
          age_range: "",
          score_total: 0,
          coin_total: 0,
        },
  
        to_online: true,
        to_online_tag: "在线",
        pre_send_time: new Date(),
  
        //发送图片
        headerImage: "",
        picValue: "",
  
        s_margin_bom: "5em",
        s_min_h: "10em",
  
        arry_menu: {
          menu_1: false,
          menu_2: false,
          menu_3: false,
          menu_4: false,
          menu_5: false,
          menu_6: false,
        },
  
        msg_count: 0,
  
        history_msg: [],
        history_tip: "历史消息",
        history_time: "",
  
        wnd_hight: 0,
        msg_pre: "",
  
        offline_state: 0
      };
    },
    sockets: {
      send_one_rst(data) {
        var self = this;
        if (data == "fail") {
          this.to_online = false;
            this.to_online_tag = "离线";
            //弹出提示
            this.offline_state += 1;
            setTimeout(() => {
              self.offline_state--;
            }, 5000);
        } else {
          this.to_online = true;
          this.to_online_tag = "在线";
          setTimeout(() => {
            if (self.$store.state.objVal.setting.msg_vol_2) {
              tool.playSound_send();
            }
          }, 100);
        }
      },
    },
    mounted() {
      const that = this;
      window.onresize = function temp() {
        //安卓手机键盘弹出关闭都执行次动作，苹果手机不执行
        that.set_MsgBlock_MinH();
      };
  
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          that.send_txt();
        }
      };
  
      this.init_page();
  
      /******************************************************** */
      //兼容性处理（兼容苹果手机）----start -------------------------
      var h1 = window.innerHeight;
      this.wnd_hight = h1;

      var client = this.$store.state.client;
      if (client.is_ios) {
        // 获取触摸坐标
        let _this = this;
        document.body.addEventListener("touchstart", _this.touchstartFunction, {
          passive: false,
        });
  
        let el = document.querySelector("#chat_page_main"); // 需要滑动的dom元素
        iosTrouchFn(el);
  
        function iosTrouchFn(el) {
          // el需要滑动的元素
          el.addEventListener("touchmove", function (e) {
            e.isSCROLL = true;
          });
          document.body.addEventListener("touchmove", _this.touchmoveFunction, {
            passive: false,
          }); // passive防止阻止默认事件不生效
        }
      }
      //兼容性处理（兼容苹果手机）----end -------------------------
      /******************************************************** */
    },
  
    /******************************************************** */
    //兼容性处理（兼容苹果手机）----start -------------------------
    beforeDestroy() {
      var client = this.$store.state.client;
      if (client.is_ios) {
        let _this = this;
        document.body.removeEventListener(
          "touchstart",
          _this.touchstartFunction,
          { passive: false }
        );
        document.body.removeEventListener("touchmove", _this.touchmoveFunction, {
          passive: false,
        });
      }
    },
    /******************************************************** */
    //兼容性处理（兼容苹果手机）----end -------------------------
  
    computed: {
      show_send_btn: function () {
        return this.txt == "" ? false : true;
      },
      txts: function () {
        var message = this.$store.state.message;
        var arr = [];
  
        var idx = tool.hasKey(message, this.to, "to");
        if (idx >= 0) {
          arr = arr.concat(message[idx]["txts"]);
        }
  
        //设置该消息已读
        this.$store.commit("set_message_item_redtag", this.to);
  
        if (arr.length > 2 && arr.length != this.msg_count) {
          this.set_scroll_msg();
        }
        // console.log(JSON.stringify(arr));
        return arr;
      },
      other_msg: function () {
        var no_read = 0;
        var message = this.$store.state.message;
        no_read = tool.calculate_noreadAll_count(message);
        return no_read;
      },
      theme_css() {
        var rtn_css = "";
        var client = this.$store.state.client;
        var themeDark = tool.is_theme_dark(this);
        if (client.is_ios) {
            rtn_css = themeDark == true ? "ios_dark" : "ios_light";
        } 
        if (client.is_andriod) {
            rtn_css = themeDark == true ? "andriod_dark" : "andriod_light";
        }
        return rtn_css;
      }
    },
  
    /**/
    updated: function () {
      this.$nextTick(function () {
        //安卓手机键盘弹出关闭都执行次动作，苹果手机不执行; 输入框内文本内容改变则两个端都执行
  
        //设置主体div高度
        var h1 = window.innerHeight;
        document.getElementById("chat_page_main").style.height = h1 + "px";
  
        //苹果手机专门处理
        var client = this.$store.state.client;
        if (client.is_ios) {
          document.getElementById("chat_page_main").style.height =
            this.wnd_hight + "px";
        }
  
        var h2 = document.getElementById("send_block").clientHeight;
        this.s_margin_bom = h2 + "px";
  
        //this.set_scroll();
      });
    },
  
    methods: {
      ...mapMutations(["get", "post", "post2"]), //引入方法
      ...mapActions([
        "act_get_userinfo",
      ]), //引入方法
  
      /******************************************************** */
      //兼容性处理（兼容苹果手机）----start -------------------------
  
      iosBlur() {
        let ua = window.navigator.userAgent;
        if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          //ios系统
          let currentPosition, timer;
          let speed = 1;
          timer = setInterval(function () {
            currentPosition =
              document.documentElement.scrollTop || document.body.scrollTop;
            currentPosition -= speed;
            window.scrollTo(0, currentPosition); //页面向上滚动
            currentPosition += speed;
            window.scrollTo(0, currentPosition); //页面向下滚动
            clearInterval(timer);
            //alert("失去焦点")
            //console.log("失去焦点")
          }, 100);
        }
      },
  
      // 滑动开始获取初始位置坐标
      touchstartFunction(e) {
        this.startY = e.touches[0].pageY;
      },
  
      // 监听手指滑动事件
      touchmoveFunction(e) {
        let el = document.querySelector("#chat_page_main"); // 需要滑动的dom元素这个为包裹滑动元素的父元素
        if (!e.isSCROLL) {
          e.preventDefault(); // 阻止默认事件(上下滑动)
          //console.log(‘阻止了’);
        } else {
          // 需要滑动的区域
          let moveY = e.touches[0].pageY;
          let top = el.scrollTop;
          let ch = el.clientHeight; // 对象最顶端和窗口最顶端之间的距离
          let scrollH = el.scrollHeight; // 含滚动内容的元素大小
          if (
            (top === 0 && moveY > this.startY) ||
            (top + ch === scrollH && moveY < this.startY)
          ) {
            e.preventDefault();
            //console.log(‘阻止了’);
          } else {
            //console.log(‘开启了’);
          }
        }
      },
  
      /******************************************************** */
      //兼容性处理（兼容苹果手机）----end -------------------------
  
      back() {
        this.$router.push({name:"msg"});
      },

      clearAdminMsg(){
        var sysdic = this.$store.state.sysdic;
        var xhc_admin_uid = sysdic.xhc_admin_uid;
        this.$store.commit('remove_message', xhc_admin_uid);
        //清除sessionStorage本地历史
        sessionStorage.removeItem(xhc_admin_uid);
        this.history_msg = [];
        this.$toast.top("重置完成,消息已全部清理~");
      },
  
      set_MsgBlock_MinH() {
        var h1 = window.innerHeight;
        var h2 = document.getElementById("send_block").clientHeight;
        var h3 = document.getElementById("math_block").clientHeight;
        this.s_min_h = h1 - h2 - h3 - 80 + "px";
      },
  
      set_scroll() {
        var div = document.getElementById("chat_page_main");
        div.scrollTop = div.scrollHeight;
      },
  
      set_scroll200() {
        var self = this;
        setTimeout(() => {
          self.set_scroll();
        }, 350);
      },
  
      set_scroll_msg() {
        var self = this;
        setTimeout(() => {
          self.set_scroll();
          //计算当前消息量
          var message = self.$store.state.message;
          var idx = tool.hasKey(message, self.to, "to");
          if (idx >= 0) {
            self.msg_count = message[idx]["txts"].length;
          }
        }, 100);
      },
  
      txtFocus() {
        this.set_scroll200();
      },
  
      init_page() {
        //初始化基本信息
        this.init_page_baseinfo();

        //历史消息
        var msg = sessionStorage.getItem(this.to);
        if (msg) {
          this.history_msg = JSON.parse(msg);
        }

        //当前没有消息时管理员自动打招呼
        var self = this;
        setTimeout(() => {
          if (self.txts.length == 0) {
            self.admin_send_msg("text","你好呢，有什么可以帮到你的呢");
          }
        }, 600);
      },
  
      init_page_baseinfo() {
        this.uid = this.$store.state.uid;
        
        var sysdic = this.$store.state.sysdic;
        var xhc_admin_uid = sysdic.xhc_admin_uid;
        this.to = xhc_admin_uid;
  
        var self = this;
        self.act_get_userinfo({
          uid: self.uid,
          success: function (u) {
            self.uinfo_from = u;
          },
        });
  
        //加载对方信息
        self.act_get_userinfo({
            uid: self.to,
            success: function (u) {
              self.uinfo_to = u;
            },
        });
      },
  
      ctrl_menu(idx) {
  
        //发图片
        if (idx == 2) {
          this.onSendPic();
        }
  
        for (var i = 1; i <= 6; i++) {
          if (i != idx) {
            this.arry_menu["menu_" + i] = false;
          }
        }
  
        if (this.arry_menu["menu_" + idx]) {
          this.arry_menu["menu_" + idx] = false;
        } else {
          this.arry_menu["menu_" + idx] = true;
          this.set_scroll200();
        }
      },
  
      wnd_click: function () {
        for (var i = 1; i <= 6; i++) {
          this.arry_menu["menu_" + i] = false;
        }
      },
  
      hide_msg_input: function () {
        var brtn = false;
        for (var i = 1; i <= 5; i++) {
          if (this.arry_menu["menu_" + i]) {
            brtn = true;
            return brtn;
          }
        }
        return brtn;
      },
  
      /* 发送图片 start */
      onSendPic() {
        this.upload_img();
      },
  
      upload_img() {
        //触发input的change事件
        var ie =
          navigator.appName == "Microsoft Internet Explorer" ? true : false;
        if (ie) {
          document.getElementById("___file_upload").click();
        } else {
          var a = document.createEvent("MouseEvents"); //FF的处理
          a.initEvent("click", true, true);
          document.getElementById("___file_upload").dispatchEvent(a);
        }
      },
  
      upload(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.picValue = files[0];
  
        var arrExt = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];
        var file_name = this.picValue.name;
        var fileExt = file_name.substr(file_name.lastIndexOf(".")).toLowerCase();
  
        if (arrExt.indexOf(fileExt) <= -1) {
          //上传文件格式不正确
          this.$toast.center("不支持您所选的图片格式~");
          return false;
        }
  
        //toast 启动动画
        this.$loading("发送中...");
  
        this.imgPreview(this.picValue);
      },
  
      postImg() {
        var self = this;
  
        //这里写接口
        var base64 = this.headerImage;
        let param = new FormData(); // 创建form对象
        param.append("imgFile", base64); //对应后台接收图片名
  
        //判断base64 是否成功, 长度>10
        if (base64.length < 10) {
          //消掉动画
          self.$loading.close();
          self.$toast.center("图片处理失败,请重新选择");
          return false;
        }
  
        this.post2({
          url: "/Common/UpLoadImage_Base64",
          data: param,
          success: function (serve_data) {
            //消掉动画
            self.$loading.close();
            //self.$toast.center('上传成功');
            var pic_url = self.$store.state.url + serve_data;
            var item = { url: pic_url, xxx: "" };
            self.send_pic(item);
          },
          error: function (err) {
            //消掉动画
            self.$loading.close();
            self.$toast.center("上传失败,请重新再来");
          },
        });
      },
  
      imgPreview(file) {
        let self = this;
        let Orientation;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, "Orientation");
        });
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;
        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader();
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            let result = this.result;
            let img = new Image();
            img.src = result;
            //判断图片是否大于4M,是就直接上传，反之压缩图片
            var pic_size = ((this.result.length * 1.0) / (1024 * 1024)).toFixed(
              2
            );
  
            if (this.result.length <= 4 * 1024 * 1024) {
              self.headerImage = this.result;
  
              self.postImg();
            } else {
              img.onload = function () {
                let data = tool.compress(img, Orientation);
                self.headerImage = data;
                self.postImg();
              };
            }
          };
        }
      },
  
      show_full(url) {
        this.$refs.myFullPic.show(url);
      },
      /* 发送图片 end */
  
      /* 消息处理 start */
      send_txt() {
        if (tool.trim(this.txt) == "") {
          this.txt = "";
          return false;
        }
  
        var msg = { msg_type: "text", msg_txt: this.txt };
        this.send(msg);
      },
      send_emoji(item) {
        var emoji_url = item.url;
        var msg = { msg_type: "emoji", msg_txt: emoji_url };
        this.send(msg);
      },
      send_gif(item) {
        var gif_url = item.url;
        var msg = { msg_type: "gif", msg_txt: gif_url };
        this.send(msg);
      },
      send_pic(item) {
        var pic_url = item.url;
        var msg = { msg_type: "pic", msg_txt: pic_url };
        this.send(msg);
      },
      send_sys(item) {
        var msg = { msg_type: item.msg_type, msg_txt: item.msg_txt };
        this.send(msg);
      },
      send: function (msg) {
        //发送消息
        var send_msg = { to: this.to, type: msg.msg_type, txt: msg.msg_txt };
        this.$socket.emit("send_one", send_msg);
        this.msg_pre = send_msg;
        this.txt = "";
        //整理消息，本地store中保存
        send_msg.dtm = new Date().Format("yyyy/MM/dd hh:mm:ss");
        this.$store.commit("push_message", send_msg);
        this.$store.commit("set_msg_count");
      },
      /* 消息处理 end */

  
      get_history_msg() {
        //为 history_time 赋值
        if (!this.history_time) {
          var message = this.$store.state.message;
          var arr = [];
          var idx = tool.hasKey(message, this.to, "to");
          if (idx >= 0) {
            arr = message[idx]["txts"];
            this.history_time = arr[0].dtm;
          }
        }
        if (this.history_msg.length > 0) {
          this.history_time = this.history_msg[0].dtm;
        }
  
        var dtm = this.history_time;
        var uid_self = this.uid;
        var uid_to = this.to;
        //console.log(dtm + '---' + uid_self + '---' + uid_to);
  
        var self = this;
        self.$loading("加载中...");
        setTimeout(() => {
          self.$loading.close();
        }, 5000);
  
        self.get({
          url: "/App/GetMsgOff_AB/?dtm=" + dtm + "&uid_self=" + uid_self + "&uid_to=" + uid_to,
          success: function (data) {
            self.$loading.close();
            //console.log(JSON.stringify(data));
            if (Array.isArray(data)) {
              //Array.isArray(data)
              //data = [{"dtm":"2024-07-29 10:37:27","uid_from":"wx_K0611PXKB2CVDBOW","uid_to":"wx_97WY78FPLRA8LQTM","state":"success","type":"emoji","txt":"https://xhc-pic.oss-cn-beijing.aliyuncs.com/emoji_img/chart_emoji/呲牙.gif"},{"dtm":"2024-07-29 10:37:29","uid_from":"wx_97WY78FPLRA8LQTM","uid_to":"wx_K0611PXKB2CVDBOW","state":"success","type":"sys_probe","txt":"探测消息"},{"dtm":"2024-07-29 10:37:36","uid_from":"wx_97WY78FPLRA8LQTM","uid_to":"wx_K0611PXKB2CVDBOW","state":"success","type":"text","txt":"你好吖，请问有什么可以帮到你的吗？"},{"dtm":"2024-07-29 10:39:04","uid_from":"wx_K0611PXKB2CVDBOW","uid_to":"wx_97WY78FPLRA8LQTM","state":"success","type":"check_album","txt":"相册审核"},{"dtm":"2024-07-29 10:39:07","uid_from":"wx_97WY78FPLRA8LQTM","uid_to":"wx_K0611PXKB2CVDBOW","state":"success","type":"sys_probe","txt":"探测消息"}];
              //data = [{"dtm":"2020-09-23 13:53:47","uid_from":"wx_97WY78FPLRA8LQTM","uid_to":"wx_BJHWOE64DSJ8S1ME","state":"success","type":"sys_kill","txt":{"kill_time":10800000,"kill_ause":"色情低俗"},"dtm":"2024/08/02 11:47:17"}]
              data = data.filter(item => {
                return ['text', 'emoji', 'gif', 'pic'].includes(item.type);
              });

              //正常情况下返回数组
              if (data.length <= 0) {
                self.history_tip = "";
                return false;
              }
  
              self.history_tip = "更多历史消息~";
              var sysmsg_dtm = {
                dtm: data[0].dtm,
                type: "sys",
                txt: data[0].dtm,
              };
              data.unshift(sysmsg_dtm);
              self.history_msg = data.concat(self.history_msg);
            } else {
              //说明后台没有拉取到值 data = {"dtm":"2020-07-19 00:00:00"};
              var sysmsg_dtm = {
                dtm: data.dtm,
                type: "sys",
                txt: data.dtm,
              };
              self.history_msg.unshift(sysmsg_dtm);
            }
  
            //本地保存 历史消息
            sessionStorage.setItem(self.to, JSON.stringify(self.history_msg));
          },
        });
      },
  
      goto_chat_specification() {
        this.$router.push({ name: "chat_specification"});
      },
      goto_guidebook() {
        this.$router.push({ name: "guidebook"});
      },

      call_labor() {
        var msg = { msg_type: "text", msg_txt: "呼叫人工客服"};
        this.send(msg);
      },

      admin_send_msg(type,txt) {
        var sysdic = this.$store.state.sysdic;
        var xhc_admin_uid = sysdic.xhc_admin_uid;
        var msg = {
          "from": xhc_admin_uid,
          "type": type,
          "txt": txt,
          "dtm": new Date().Format("yyyy/MM/dd hh:mm:ss")
        }
        this.$store.dispatch('act_push_message', msg);
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  #chat_page_main {
  height: 100%;
  overflow-y: auto;
}

#___file_upload {
  position: absolute;
  left: -999px;
}

.nav-top {
  position: fixed;
  top: 0;
  width: 100%;
  .other-msg {
    display: inline-block;
    margin-left: 0.1rem;
    height: 1.6rem;
    line-height: 1.6rem;
    min-width: 1.6rem;
    border-radius: 50%;
    background-color: #fff;
    color: #333;
    text-align: center;
  }
  .online {
    margin-left: 0.5rem;
    color: #4b0df7;
  }

  .no-online {
    margin-left: 0.5rem;
    color: #666;
  }
}

.msg-block {
  padding: 0 0.8rem 0.8rem;
  margin-top: 2.6rem;
  margin-bottom: 5rem;
  .msg-system {
      font-size: 0.8rem;
      height: 1.6rem;
      line-height: 1.6rem;
      border-radius: 1rem;
      color: #a6a6a6;
      display: inline-block;
      padding: 0 1.5rem;
  }
  .load-history-msg {
    text-align: center;
    font-size: 0.85rem;
    margin-top: 0.8rem;
    color:#8a61ff;
    line-height: 1.35rem;
    .history-msg-img{
      width: 1.2rem;
      height: 1.2rem;
      margin-right: .2rem;
    }
  }
  .no-history-msg {
    text-align: center;
    font-size: 0.8rem;
    margin-top: 0.8rem;
    color: #dcdcdc;
  }
  .msg-item {
    margin: 0.5rem 0;
    .msg-img {
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 50%;
    }
    .msg-tip{
      color: red;
      display: none;
    }
    .msg-content {
      max-width: 66%;
      line-height: 1.8rem;
      border-radius: 0.3rem;
      padding: 0.5rem;
      color: #333;
      word-wrap: break-word;
    }
    .sys-left {
      margin-left: 0.5rem;
      background-color: #DEDEDE;
    }
    .tips {
      margin-right: 0.5rem;
      font-size: 0.75rem;
      color: #c95c03;
    }
    .tips-txt {
      font-size: 0.6rem;
      line-height: 1rem;
      color: #666;
    }
    .msg-left-color {
      background-color: #fd94b2;
    }
    .msg-Angle-left {
      width: 0;
      height: 0;
      border-width: 0.5rem;
      border-style: solid;
      border-color: transparent #fd94b2 transparent transparent;
    }
    .msg-right-color {
      background-color: #9ae6e2;
      margin-left: .8rem;
    }
    .msg-Angle-right {
      width: 0;
      height: 0;
      border-width: 0.5rem;
      border-style: solid;
      border-color: transparent transparent transparent #9ae6e2;
    }
    .msg-emoji {
      margin: 0 0.8rem;
      max-height: 5rem;
      max-width: 5rem;
    }
    .msg-gif {
      margin: 0 0.8rem;
      max-width: 35%;
    }
    .msg-pic {
      margin: 0 0.8rem;
      max-width: 40%;
      max-height: 6rem;
    }
    .msg-sys {
      max-width: 66%;
      line-height: 1.8rem;
      background-color: #9ae6e2;
      border-radius: 0.3rem;
      padding: 0.5rem;
      margin: 0 1rem;
      color: #fff;
      word-wrap: break-word;
    }
    .register-guidance-block {
    max-width: 66%;
    margin-left: 0.5rem;
    background-color: #FDFDFD;
    border-radius: 0.5rem;
    .register-hello {
      height: 5rem;
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
      background-image: url(../../assets/img/new2024/bg-photo.png);
      background-size: cover;
      span {
        font-size: 1rem;
        font-weight: bold;
        color: #fff;
      }
    }
    .txt {
      padding: 0 0.5rem 1rem 0.5rem;
      .line {
        margin: 0.5rem 0;
        border-top: 1px solid #DFDFDF;
      }
      p {
        font-size: 0.9rem;
        font-weight: 500;
        color: #333;
      }
      a {
        font-size: 0.9rem;
        color: #666;
      }
    }
  }
  .tips-msg {
    max-width: 66%;
    margin-left: 0.5rem;
    background-color: #FDFDFD;
    border-radius: 0.5rem;
    padding: 0.8rem;
    color: #333;
    word-wrap: break-word;
      .title {
        font-size: 1rem;
        font-weight: bold;
        line-height: 1.5rem;
      }
      .content {
        margin-top: 0.5rem;
        font-size: 0.75rem;
        color: #BEBEBE;
        line-height: 1rem;
      }
      .line {
        margin: 0.5rem 0;
        border-top: 1px solid #DFDFDF;
      }
      a {
        font-size: 0.9rem;
        color: #BEBEBE;
      }
      .call-labor {
        margin-top: 1rem;
        color: rgb(0, 102, 255);
        font-size: 0.65rem;
      }
    }
  }
  .sys-msg {
    margin-top: 1rem;
  }
}

.send-block {
  width: 100%;
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  background-color: #ededed;
  .send-txt-con {
    margin: 0 0.5rem;
    padding: 0.22rem 0.3rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 2rem;
    background-color: #fff;
    border: #dcdcdc 1px solid;
    .send-txt {
      outline: none;
      border: none;
      font-size: 0.95rem;
      font-weight: 500;
      color: #333;
      height: 1.8rem;
      margin: 0 0.5rem;
      padding-left: 0.3rem;
    }
    .btn-send {
      height: 1.8rem;
      line-height: 1.8rem;
      width: 3.6rem;
      text-align: center;
      border: 1px solid #dcdcdc;
      background: linear-gradient( 90deg, #A264E7 0%, #FE9CC0 100%);
      border-radius: 1rem;
      color: #fff;
      span {
        font-size: 0.8rem;
      }
    }
  }
}

.send-img {
  justify-content: space-between;
  margin: 0.5rem;
  .send-img-item {
    width: 1.5rem;
    height: 1.5rem;
  }
}


.ios_light {
  background-color: #F7F7F7;
  .send-block {
    background-color: #F7F7F7;
  }
}
.andriod_light {
  background-color: #EDEDED;
}
//夜间模式
.ios_dark {
    background-color: #1E1E1E;
    .msg-block {
      .msg-item {
        .msg-left-color {
            background-color: #2F2E33;
            color: #DFDFDF;
          }
          .msg-Angle-left {
            border-color: transparent #2F2E33 transparent transparent;
          }
          .msg-right-color {
            background-color: #402B6A;
            color: #fff;
          }
          .msg-Angle-right {
            border-color: transparent transparent transparent #402B6A;
          }
        .msg-system {
          background-color: transparent;
        }
        .register-guidance-block {
          background-color: #2F2E33;
          .txt {
            p {
              color: #FFFFFF;
            }
            a {
              color: #DFDFDF;
            }
          }
          .line {
            border-top: 1px solid #999;
          }
        }
        .tips-msg {
          background-color: #2F2E33;
          .title {
            color: #FFFFFF;
          }
          .content {
            color: #FFFFFF;
          }
          a {
            color: #DFDFDF;
          }
          .call-labor {
            color: rgb(0, 102, 255);
          }
          .line {
            border-top: 1px solid #999;
          }
        }
      }
    }
    
    .send-block {
      background-color: #1E1E1E;
      .send-txt-con {
        background-color: #282828;
        border: #2F2E33 1px solid;
        .send-txt {
          color: #DFDFDF;
          background-color: #282828;
        }
        .btn-send {
          border: 1px solid #282828;
        }
      }
      
    }
}
.andriod_dark {
    background-color: #111111;
    .msg-block {
      .msg-item {
        .msg-left-color {
            background-color: #2F2E33;
            color: #DFDFDF;
          }
          .msg-Angle-left {
            border-color: transparent #2F2E33 transparent transparent;
          }
          .msg-right-color {
            background-color: #402B6A;
            color: #fff;
          }
          .msg-Angle-right {
            border-color: transparent transparent transparent #402B6A;
          }
        .msg-system {
          background-color: transparent;
        }
        .tips-msg {
          background-color: #2F2E33;
          .title {
            color: #FFFFFF;
          }
          .content {
            color: #FFFFFF;
          }
          a {
            color: #DFDFDF;
          }
          .call-labor {
            color: rgb(0, 102, 255);
          }
        }
        .register-guidance-block {
          background-color: #2F2E33;
          .txt {
            p {
              color: #FFFFFF;
            }
            a {
              color: #DFDFDF;
            }
          }
        }
      }
    }
    
    .send-block {
      background-color: #111111;
      .send-txt-con {
        background-color: #282828;
        border: #2F2E33 1px solid;
        .send-txt {
          color: #DFDFDF;
          background-color: #282828;
        }
        .btn-send {
          border: 1px solid #282828;
        }
      }
      
    }
}
  </style>
  